export interface ListImageRowItem {
  type: 'image'
  text?: string
  gridImageUrls: string[]
  isEnabled?: boolean
}
